import FieldSet from '../../FieldSet';

import { VotesCount } from './VotesCount';

export class VotesFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [VotesCount];
  }

  get title() {
    return 'Votes';
  }
}
